/*
  bfroz-quiz.js : port vanilla de _source/src/components/shop/FlavorQuiz.tsx
  (machine à états intro → questions → résultat), sans dépendance.

  Données : <script type="application/json" data-quiz-data> de la section flavor-quiz :
    { questions: [{ text, options: [{ label, flavor: <handle> }] }],
      flavors: { <handle>: { data: <objet flavor-data>, description, url } } }
  - Teinte « live » : vibeColor de la saveur dominante parmi les réponses données
    (égalité : la première répondue gagne, comme le tri stable de la source), sinon #00BDD1.
  - Barre de progression : 32 px pour la question courante, 12 px sinon ; teinte jusqu'à la
    courante, rgba(0,31,46,0.15) après.
  - Survol d'une réponse : bordure gauche à la couleur de SA saveur (transparente au repos).
  - Chaque écran rejoue animate-fade-in-up (la source remonte le composant : key={current}).
  - window.BFROZ.motion.refresh() après chaque changement d'écran.
*/
(function () {
  'use strict';

  var BFROZ = (window.BFROZ = window.BFROZ || {});
  if (BFROZ.quizReady) return;
  BFROZ.quizReady = true;

  var DEFAULT_TINT = '#00BDD1';
  var INACTIVE_DOT = 'rgba(0,31,46,0.15)';

  var decodeArea = null;
  function decodeDeepLocal(v) {
    if (typeof v === 'string') {
      if (v.indexOf('&') === -1) return v;
      if (!decodeArea) decodeArea = document.createElement('textarea');
      decodeArea.innerHTML = v;
      return decodeArea.value;
    }
    if (Object.prototype.toString.call(v) === '[object Array]') {
      for (var i = 0; i < v.length; i++) v[i] = decodeDeepLocal(v[i]);
      return v;
    }
    if (v && typeof v === 'object') {
      for (var k in v) if (Object.prototype.hasOwnProperty.call(v, k)) v[k] = decodeDeepLocal(v[k]);
      return v;
    }
    return v;
  }

  function refreshMotion() {
    if (BFROZ.motion && typeof BFROZ.motion.refresh === 'function') BFROZ.motion.refresh();
  }
  function replay(el) {
    if (!el) return;
    el.classList.remove('animate-fade-in-up');
    void el.offsetWidth;
    el.classList.add('animate-fade-in-up');
  }

  function init(section) {
    if (section.__bfrozQuiz) return;
    section.__bfrozQuiz = true;

    var dataEl = section.querySelector('[data-quiz-data]');
    if (!dataEl) return;
    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    // Les textes viennent de `| t` (HTML déjà échappé) puis `| json` : « C&#39;est » s'afficherait tel quel
    // en textContent. Décodage identique à celui de bfroz-cart.js (repli local si le script n'est pas là).
    data = (window.BFROZ && window.BFROZ.decodeDeep) ? window.BFROZ.decodeDeep(data) : decodeDeepLocal(data);
    var questions = data.questions || [];
    var flavors = data.flavors || {};

    var screens = {
      intro: section.querySelector('[data-quiz-screen="intro"]'),
      questions: section.querySelector('[data-quiz-screen="questions"]'),
      result: section.querySelector('[data-quiz-screen="result"]')
    };
    var dots = section.querySelectorAll('[data-quiz-dot]');
    var questionEl = section.querySelector('[data-quiz-question]');
    var optionsEl = section.querySelector('[data-quiz-options]');
    var template = section.querySelector('[data-quiz-option-template]');
    var result = {
      glow: section.querySelector('[data-quiz-result-glow]'),
      image: section.querySelector('[data-quiz-result-image]'),
      vibe: section.querySelector('[data-quiz-result-vibe]'),
      name: section.querySelector('[data-quiz-result-name]'),
      tagline: section.querySelector('[data-quiz-result-tagline]'),
      description: section.querySelector('[data-quiz-result-description]'),
      link: section.querySelector('[data-quiz-result-link]')
    };
    if (!screens.intro || !screens.questions || !screens.result || !questionEl || !optionsEl || !template) return;

    var current = 0;
    var answers = [];

    // Saveur la plus choisie ; à égalité, la première répondue (Object.entries + sort stable).
    function dominant() {
      if (!answers.length) return null;
      var counts = {};
      var order = [];
      for (var i = 0; i < answers.length; i++) {
        var f = answers[i];
        if (!Object.prototype.hasOwnProperty.call(counts, f)) {
          counts[f] = 0;
          order.push(f);
        }
        counts[f] += 1;
      }
      var best = order[0];
      for (var j = 1; j < order.length; j++) {
        if (counts[order[j]] > counts[best]) best = order[j];
      }
      return best;
    }
    function colorOf(handle) {
      var f = handle ? flavors[handle] : null;
      return f && f.data && f.data.vibeColor ? f.data.vibeColor : null;
    }
    function tint() {
      return colorOf(dominant()) || DEFAULT_TINT;
    }

    function show(name) {
      for (var k in screens) {
        if (!Object.prototype.hasOwnProperty.call(screens, k) || !screens[k]) continue;
        if (k === name) {
          screens[k].classList.remove('hidden');
          replay(screens[k]);
        } else {
          screens[k].classList.add('hidden');
        }
      }
      refreshMotion();
    }

    function renderQuestion() {
      var q = questions[current];
      if (!q) return;
      var t = tint();
      for (var i = 0; i < dots.length; i++) {
        dots[i].style.width = (i === current ? 32 : 12) + 'px';
        dots[i].style.backgroundColor = i <= current ? t : INACTIVE_DOT;
      }
      questionEl.textContent = q.text || '';
      optionsEl.innerHTML = '';
      (q.options || []).forEach(function (opt, index) {
        var node = template.content.firstElementChild.cloneNode(true);
        var optColor = colorOf(opt.flavor) || t;
        var letter = node.querySelector('[data-quiz-letter]');
        var label = node.querySelector('[data-quiz-label]');
        if (letter) letter.textContent = String.fromCharCode(65 + index);
        if (label) label.textContent = opt.label || '';
        node.style.borderLeftColor = 'transparent';
        node.addEventListener('mouseenter', function () {
          node.style.borderLeftColor = optColor;
        });
        node.addEventListener('mouseleave', function () {
          node.style.borderLeftColor = 'transparent';
        });
        node.addEventListener('click', function () {
          answer(opt.flavor);
        });
        optionsEl.appendChild(node);
      });
    }

    function renderResult() {
      var handle = dominant();
      var f = handle ? flavors[handle] : null;
      if (!f) return;
      var d = f.data || {};
      var color = d.vibeColor || DEFAULT_TINT;
      if (result.glow) result.glow.style.backgroundColor = color;
      if (result.image) {
        result.image.src = (d.images && d.images.pack) || result.image.src;
        result.image.alt = d.name || '';
        result.image.style.filter = 'drop-shadow(0 30px 50px ' + color + '88)';
      }
      if (result.vibe) {
        result.vibe.textContent = d.vibe || '';
        result.vibe.style.color = color;
      }
      if (result.name) result.name.textContent = (d.name || '').toUpperCase();
      if (result.tagline) result.tagline.textContent = '"' + (d.tagline || '') + '"';
      if (result.description) result.description.textContent = f.description || '';
      if (result.link) {
        if (f.url) result.link.href = f.url;
        result.link.style.backgroundColor = color;
        result.link.style.boxShadow = '0 10px 40px ' + color + '66';
      }
    }

    function answer(flavor) {
      answers.push(flavor);
      if (current + 1 >= questions.length) {
        renderResult();
        show('result');
      } else {
        current += 1;
        renderQuestion();
        replay(screens.questions);
        refreshMotion();
      }
    }
    function start() {
      current = 0;
      answers = [];
      renderQuestion();
      show('questions');
    }
    function reset() {
      current = 0;
      answers = [];
      show('intro');
    }

    section.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-quiz-start]')) {
        e.preventDefault();
        start();
      } else if (t.closest('[data-quiz-retake]')) {
        e.preventDefault();
        reset();
      }
    });
  }

  function initAll(root) {
    var nodes = (root || document).querySelectorAll('[data-quiz]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  initAll(document);

  // Éditeur de thème : la section est réinjectée sans exécuter ses scripts.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelectorAll) initAll(e.target);
  });
})();
